import React from 'react';
import DonutChart from './common/charts/Donut-chart';
import BarChart from './common/charts/Bar-chart';
import CustomBarChart from './common/charts/Bar-chart';

const TestCharts = () => {
    const person = [
        { name: 'In-person', value: 40 },
        { name: 'Virtual', value: 60 },
    ];
    
    return (
        <div className='h-[500px]'>
            <DonutChart data={person}></DonutChart>
            {/* <h1>Charts!!!</h1> */}
            {/* <CustomBarChart></CustomBarChart> */}
        </div>
      );
};

export default TestCharts;